export default {
  props: {
    id: String,
    label: String,
    name: String,
    colorScheme: String,
    icon: String,
    enterFunc: {
      type: Function,
      default: () => null,
    },
    inputFunc: {
      type: Function,
      default: () => null,
    },
    properties: {
      type: Object,
      default: () => {},
    },
    classes: {
      type: Array,
      default: () => [],
    },
    defaultChecked: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  created() {
    this.checked = this.defaultChecked;
  },
  methods: {
    buildClasses() {
      const result = [];

      if (this.classes) {
        result.concat(this.classes);
      }

      if (this.colorScheme) {
        result.push(`${this.$options.name}--${this.colorScheme}`);
      }

      if (this.icon) {
        result.push(`${this.$options.name}--icon`);
      }

      return result;
    },
  },
  watch: {
    defaultChecked(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.checked = this.defaultChecked;
      }
    },
  },
};
